const defaultState = {
    itemsPerPage: 12,
    itemsStyle: "CARD",
    compareList: []
}

export const state = {
    ...defaultState
}

export const getters = {
    itemsSmePerPage: state => state.itemsPerPage,
    itemsStyle: state => state.itemsStyle,
    compareList: state => state.compareList
}

export const mutations = {
    setItemsPerPage(state, value){
        state.itemsPerPage = value
    },
    setItemsStyle(state, value){
        state.itemsStyle = value
    },
    setCompareList(state, value){
        state.compareList = value
    }
}

export const actions = {
    setItemsPerPage({commit}, value){
        commit("setItemsPerPage", value)
    },
    setItemsStyle({commit}, value){
        commit("setItemsStyle", value)
    },
    setCompareList({commit}, value){
        commit("setCompareList", value)
    }
}